import React from 'react';
import { NavLink } from 'react-router-dom';


const SignedInLinks = () => {
    return (
        <div className="sign">
            <NavLink className='signUp' to='/signup'>Sign Up </NavLink>
            <NavLink className='signIn' to='/login'>Log In</NavLink>
        </div>
    );
}

export default SignedInLinks;